import request from '@/utils/request'

export function getAllBoard(openid, page, limit, boardName, boardUid) {
  return request({
    url: '/sivadm/device/admin/board/list',
    method: 'get',
    params: { openid, page, limit, boardName, boardUid },
  })
}

export function getUserOwnedBoard(openid) {
 return request({
  url: '/sivadm/user-board/owned/' + openid,
  method: 'get',
 })
}

export function getUserCoopBoard(openid) {
 return request({
  url: '/sivadm/user-board/coop/' + openid,
  method: 'get',
 })
}

export function getUserAllBoard(openid) {
 return request({
  url: '/sivadm/user-board/all/' + openid,
  method: 'get',
 })
}

export function getBoardInfo(openid, board_guid) {
 return request({
  url: '/sivadm/device/admin/board',
  method: 'get',
  params: { openid, board_guid },
 })
}

export function getBoardRunRcd(openid, board_guid, boot_count) {
  return request({
    url: '/sivadm/device/ctrl/board/record/run',
    method: 'get',
    params: { openid, board_guid, boot_count },
  })
}

export function getBoardLogList(openid, board_guid) {
    return request({
      url: '/sivadm/device/ctrl/board/record/log',
      method: 'get',
      params: { openid, board_guid },
    })
  }

export function getBoardRTInfo(board_guid) {
 return request({
  url: '/sivadm/device/ctrl/board/rtctl',
  method: 'get',
  params: { board_guid },
 })
}

export function getBoardRTInfoV5Full(openid, board_guid, subdev_type) {
  return request({
   url: '/sivadm/device/ctrl/board/rtctl/V5/full',
   method: 'get',
   params: { openid, board_guid, subdev_type },
  })
 }

export function getBoardRTInfoV3Full(openid, board_guid, subdev_type) {
return request({
  url: '/sivadm/device/ctrl/board/rtctl/V3/full',
  method: 'get',
  params: { openid, board_guid, subdev_type },
})
}

export function getBoardExtraConfig(board_guid) {
  return request({
   url: '/sivadm/device/ctrl/board/config/extra',
   method: 'get',
   params: { board_guid },
  })
}
export function setBoardExtraConfig(data) {
  return request({
    url: '/sivadm/device/ctrl/board/config/extra',
    method: 'post',
    data,
  })
}
export function getBoardResConfig(openid, board_guid) {
 return request({
  url: '/sivadm/device/ctrl/board/config',
  method: 'get',
  params: { board_guid },
 })
}

export function setBoardResConfig(data) {
 return request({
  url: '/sivadm/device/ctrl/board/config',
  method: 'post',
  data,
 })
}

export function setBoardLangIndex(data) {
  return request({
   url: '/sivadm/device/ctrl/board/config/lang',
   method: 'post',
   data,
  })
 }

export function setBoardTaskNum(chip_id, max_task_num) {
  return request({
   url: '/sivadm/device/ctrl/board/config/tasknum',
   method: 'post',
   params: {chip_id, max_task_num},
  })
}

export function setBoardShowLimit(chip_id, show_limit) {
  return request({
   url: '/sivadm/device/ctrl/board/config/showlimit',
   method: 'post',
   params: {chip_id, show_limit},
  })
}

export function getThemeScenes(openid, board_guid) {
 return request({
  url: '/sivadm/theme/scenes',
  method: 'get',
  params: { openid },
 })
}

export function sceneSkip(openid, board_guid, task_id) {
 return request({
  url: '/sivadm/device/ctrl/board/rtctl/scene/skip',
  method: 'post',
  params: { openid, board_guid, task_id, next_hop_index: 1 },
 })
}

export function sceneSkipAny(openid, board_guid, task_id, next_scene_id) {
  return request({
   url: '/sivadm/device/ctrl/board/rtctl/scene/skip_any',
   method: 'post',
   params: { openid, board_guid, task_id, next_scene_id},
  })
 }

export function sceneExecFAs(openid, board_guid, task_id, scene_id) {
return request({
  url: '/sivadm/device/ctrl/board/rtctl/scene/exec_fa',
  method: 'post',
  params: { openid, board_guid, task_id, scene_id},
})
}

export function taskOp(openid, board_guid, task_id, op_id) {
return request({
  url: '/sivadm/device/ctrl/board/rtctl/task_op',
  method: 'post',
  params: { openid, board_guid, task_id, op_id},
})
}

export function fwUpgrade(openid, board_guid) {
 return request({
  url: '/sivadm/device/ctrl/firmware/upgrade',
  method: 'post',
  data: { openid, board_guid },
 })
}

export function fwUpgradeByUrl(openid, board_guid, firmware_url) {
 return request({
  url: '/sivadm/device/ctrl/firmware/upgrade/url',
  method: 'post',
  params: { openid, board_guid, firmware_url },
 })
}

export function getFwUpdProgress(board_guid) {
 return request({
  url: '/sivadm/device/ctrl/firmware/progress',
  method: 'get',
  params: { board_guid },
 })
}

export function themeUpgrade(openid, board_guid) {
 return request({
  url: '/sivadm/device/ctrl/board/theme/upgrade',
  method: 'post',
  params: { openid, board_guid },
 })
}

export function getThmUpdProgress(board_guid) {
 return request({
  url: '/sivadm/device/ctrl/board/theme/upgrade/progress',
  method: 'get',
  params: { board_guid },
 })
}

export function getThmUpgadeUrl(openid, board_guid) {
 return request({
  url: '/sivadm/device/ctrl/board/theme/upgrade/url',
  method: 'get',
  params: { openid, board_guid },
 })
}

export function setThmUpgadeUrl(data) {
 return request({
  url: '/sivadm/device/ctrl/board/theme/upgrade/url',
  method: 'post',
  data,
 })
}

export function getPhyPortStatus(openid, board_guid) {
 return request({
  url: '/sivadm/device/ctrl/board/rtctl/phyports',
  method: 'get',
  params: { openid, board_guid },
 })
}

export function setPhyPortStatus(data) {
 return request({
  url: '/sivadm/device/ctrl/board/rtctl/phyports',
  method: 'post',
  data,
 })
}

export function getPhyPortStatus2(openid, board_guid) {
  return request({
   url: '/sivadm/device/ctrl/board/rtctl/phyports2',
   method: 'get',
   params: { openid, board_guid },
  })
 }

export function setPhyPortStatus2(data) {
  return request({
   url: '/sivadm/device/ctrl/board/rtctl/phyports2',
   method: 'post',
   data,
  })
 }

 export function getBoardLocalModuleInfo(board_guid) {
  return request({
   url: '/sivadm/device/ctrl/board/rtctl/localmod',
   method: 'get',
   params: { board_guid },
  })
 }

export function addBoard(data) {
 return request({
  url: '/sivadm/device/admin/board',
  method: 'post',
  data,
 })
}

export function delBoard(data) {
 return request({
  url: '/sivadm/device/admin/board',
  method: 'delete',
  data,
 })
}

export function refurbBoard(data) {
  return request({
   url: '/sivadm/device/admin/board/refurb',
   method: 'post',
   data,
  })
 }

export function setBoardOwner(data) {
 return request({
  url: '/sivadm//device/admin/board/owner',
  method: 'post',
  data,
 })
}

export function getBoardSubDevInfo(board_guid, subdev_type) {
 return request({
  url: '/sivadm/device/ctrl/board/subdev/all',
  method: 'get',
  params: { board_guid, subdev_type },
 })
}

export function setBoardSubDevOperate(data) {
 return request({
  url: '/sivadm/device/ctrl/board/subdev/op',
  method: 'post',
  data,
 })
}

export function getBoardCoopInfo(openid, board_guid) {
 return request({
  url: '/sivadm/device/ctrl/board/share',
  method: 'get',
  params: { openid, board_guid },
 })
}

export function setBoardCoopInfo(data) {
 return request({
  url: '/sivadm/device/ctrl/board/share',
  method: 'post',
  data,
 })
}

export function delBoardCoopInfo(data) {
 return request({
  url: '/sivadm/device/ctrl/board/share',
  method: 'DELETE',
  data,
 })
}

export function boardReset(openid, board_guid) {
 return request({
  url: '/sivadm//device/ctrl/board/rtctl/reboot',
  method: 'post',
  params: { openid, board_guid },
 })
}

export function getBoardThemeInfo(board_guid) {
  return request({
    url: '/sivadm/device/ctrl/board/theme/info',
    method: 'get',
    params: { board_guid },
   })
}

export function delBoardThemeInfo(board_guid, theme_index) {
  return request({
    url: '/sivadm/device/ctrl/board/theme/info',
    method: 'delete',
    params: { board_guid, theme_index },
   })
}

export function getBoardIntParam (openid, board_guid, param_id, admin_param = false) {
  return request({
    url: '/sivadm/device/ctrl/board/config/intparam',
    method: 'get',
    params: { board_guid, param_id, admin_param },
  })
}

export function getBoardStrParam (openid, board_guid, param_id) {
  return request({
    url: '/sivadm/device/ctrl/board/config/strparam',
    method: 'get',
    params: { board_guid, param_id },
  })
}

export function setBoardIntParam (data) {
  return request({
    url: '/sivadm/device/ctrl/board/config/intparam',
    method: 'post',
    data,
  })
}

export function setBoardStrParam (data) {
  return request({
    url: '/sivadm/device/ctrl/board/config/strparam',
    method: 'post',
    data,
  })
}

export function setBoardMultiTheme (data) {
  return request({
    url: '/sivadm/device/ctrl/board/config/multitheme',
    method: 'post',
    data,
  })
}
